module.exports = __webpack_public_path__ + "media/images/icons/v2/pen-tool-plus-1f7ce5c3330754a9bbb4b1c27a32286b.svg";